import Form from "./components/Form";
import ProductList from "./components/ProductList";
import "./App.scss";

function App() {
  return (
    <div className="App">
      <Form />
      <ProductList />
    </div>
  );
}

export default App;
